<template>
  <div class="bg-black fixed inset-0 flex-center">
    <client-only>
      <template v-if="error">
        <p class="text-white text-3xl">Something went wrong.</p>
      </template>
      <template v-else-if="pending">
        <p class="text-white text-3xl">Loading</p>
      </template>
      <template v-else>
        <div>
          <core-media-player
            v-if="isStreamable"
            :type="file.fileType"
            :src="fileUrl"
            :poster-src="posterSrc"
            show-logo
            @logo-click="goToEmbeddedFile"
            ref="mediaPlayer"
            :width="`${width}px`"
            :height="`${height}px`"
          />
        </div>
      </template>
    </client-only>
  </div>
</template>

<script setup>
  import {FILE_TYPES} from '~/constants/files.js';

  useForeverHead({
    title: 'FOREVER Media Player'
  });

  const mediaPlayer = ref();
  const {
    user_id: userId,
    file_id: fileId,
    share_token: shareToken
  } = useRoute().params;

  const {data: file, refresh, pending, error} = await useAsyncData(
    'get-embed-file',
    () => useFileApi().getFileDetails([fileId], { userId, shareToken }),
    {
      transform: res => res && res[0],
      server: false
    }
  );

  const isVideo = computed(() => isStreamable.value && file.value.fileType === FILE_TYPES.video);
  const isAudio = computed(() => isStreamable.value && file.value.fileType === FILE_TYPES.audio);
  const isStreamable = computed(() => file.value.streamable || isAudio.value);
  const fileUrl = computed(() => file.value.preview_url || file.value.download_items[0].path);
  const posterSrc = computed(() => isVideo.value && file.value.images.preview);
  const {width, height} = useWindowSize();

  const goToEmbeddedFile = () => {
    mediaPlayer.value.pause();
    const url = `${window.location.origin}/app/users/${userId}/files/${fileId}/${shareToken}`;
    window.open(url, '_blank');
  };
</script>
